module.exports = __webpack_public_path__ + "static/media/player_silhouette.64c1c949.svg";